export enum ECollapsedNotes {
	PUBLIC = 'public',
	PRIVATE = 'private',
	BOTH = 'both',
}

export interface DefaultNotesLineProps {
	onOpenPublic: () => void;
	onOpenPrivate: () => void;
	labels: {
		initialPublic: string;
		initialPrivateNote: string;
		publicTooltip: string;
		privateTooltip: string;
	};
}

export interface OneOpenNoteProps {
	value: string | undefined;
	labels: {
		openNote: string;
		closedNote: string;
		tooltip: string;
		clear: string;
	};
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	onClick?: () => void;
	onCancel: () => void;
}

export interface TwoOpenNoteProps {
	publicValue?: string;
	privateValue?: string;
	isPublicFirst?: boolean;
	labels: {
		public: string;
		private: string;
		publicTooltip: string;
		privateTooltip: string;
		clear: string;
	};
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>, type: ECollapsedNotes) => void;
	onCancel: (isPublic: boolean) => void;
}

export interface OpenNoteProps {
	openNote: string;
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	value?: string;
	labels: {
		tooltip: string;
		clear: string;
	};
	onCancel: () => void;
	isCancelDisabled: boolean;
}

export interface AddPublicPrivateNotesProps {
	initialPrivateNote?: string;
	initialPublicNote?: string;
	onChange: (publicNote?: string, privateNote?: string) => void;
}
